<template>
    <div>
        <h2>{{ step.title }}</h2>
        <p class="step__notice">
            All fields with an asterisk are required
            <i class="fas fa-asterisk"></i>
        </p>

        <InputRadioGroup
            name="is_eligible_to_work"
            :required="isRequired('is_eligible_to_work')"
            :error="form.errors.get('is_eligible_to_work')"
            v-model="form.is_eligible_to_work"
            :options="getField('is_eligible_to_work').options"
            @input="form.errors.clear('is_eligible_to_work')"
        >
            <template v-slot:question>
                {{ getField("is_eligible_to_work").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            v-if="form.is_eligible_to_work == 'no'"
            name="ineligibility_reason"
            :required="isRequired('ineligibility_reason')"
            :error="form.errors.get('ineligibility_reason')"
            v-model="form.ineligibility_reason"
            :options="getField('ineligibility_reason').options"
            :form="form"
            @textarea-updated="form[$event.field] = $event.value"
            @input="form.errors.clear('ineligibility_reason')"
        >
            <template v-slot:question>
                {{ getField("ineligibility_reason").question }}
            </template>
        </InputRadioGroup>

        <InputRadioGroup
            name="current_employment_situation"
            :required="isRequired('current_employment_situation')"
            :error="form.errors.get('current_employment_situation')"
            v-model="form.current_employment_situation"
            :options="getField('current_employment_situation').options"
            @input="form.errors.clear('current_employment_situation')"
        >
            <template v-slot:question>
                {{ getField("current_employment_situation").question }}
            </template>
        </InputRadioGroup>

        <template v-if="form.current_employment_situation == 'working'">
          <InputNumber
                name="average_weekly_work_hours"
                :required="isRequired('average_weekly_work_hours')"
                :error="form.errors.get('average_weekly_work_hours')"
                v-model="form.average_weekly_work_hours"
            >
                <template v-slot:question>
                    {{ getField("average_weekly_work_hours").question }}
                </template>
                <template v-slot:description>
                    {{ getField("average_weekly_work_hours").description }}
                </template>
            </InputNumber>

        <InputRadioGroup
                name="is_zero_hour_contract"
                :required="isRequired('is_zero_hour_contract')"
                :error="form.errors.get('is_zero_hour_contract')"
                v-model="form.is_zero_hour_contract"
                :options="getField('is_zero_hour_contract').options"
                @input="form.errors.clear('is_zero_hour_contract')"
            >
                <template v-slot:question>
                    {{ getField("is_zero_hour_contract").question }}
                </template>
                <template v-slot:description>
                    {{ getField("is_zero_hour_contract").description }}
                </template>
            </InputRadioGroup>
        </template>

        <InputYearsMonths
            v-if="form.current_employment_situation == 'not_working'"
            name="how_long_since_last_worked"
            :error="
                form.errors.get('how_long_since_last_worked_years') ||
                form.errors.get('how_long_since_last_worked_months')
            "
            :years="form.how_long_since_last_worked_years"
            @years-updated="form.how_long_since_last_worked_years = $event, form.has_never_worked = false"
            :months="form.how_long_since_last_worked_months"
            @months-updated="form.how_long_since_last_worked_months = $event, form.has_never_worked = false"
        >
            <template v-slot:question>
                {{ getField("how_long_since_last_worked_months").question }}
            </template>
            <template v-slot:description>
                {{
                    getField("how_long_since_last_worked_months")
                        .description
                }}
            </template>

            <template v-slot:input>
                <div class="form-group">Or</div>
                <div class="form-group d-flex align-items-center">
                    <input
                        type="checkbox"
                        id="has_never_worked"
                        v-model="form.has_never_worked"
                        @change="clearfields()"
                    />
                    <label for="has_never_worked" class="m-0 ms-2 form-label">
                        I have never worked
                    </label>
                </div>
            </template>
        </InputYearsMonths>

        <InputText
            v-if="form.current_employment_situation == 'unable_to_work'"
            name="why_unable_to_work"
            :required="isRequired('why_unable_to_work')"
            :error="form.errors.get('why_unable_to_work')"
            v-model="form.why_unable_to_work"
            :is-multiline="true"
        >
            <template v-slot:question>
                {{ getField("why_unable_to_work").question }}
            </template>
            <template v-slot:description>
                {{ getField("why_unable_to_work").description }}
            </template>
        </InputText>

         <InputNumber
            v-if="form.current_employment_situation == 'volunteering'"
            name="volunteering_hours_per_week"
            :required=true
            :error="form.errors.get('volunteering_hours_per_week')"
            v-model="form.volunteering_hours_per_week"
        >
            <template v-slot:question>
                {{ getField("volunteering_hours_per_week").question }}
            </template>
            <template v-slot:description>
                {{ getField("volunteering_hours_per_week").description }}
            </template>
         </InputNumber>
    </div>
</template>

<script>
import InputText from "../Form/InputText";
import InputNumber from "../Form/InputNumber";
import InputRadioGroup from "../Form/InputRadioGroup";
import InputYearsMonths from "../Form/InputYearsMonths";
import Form from "../../Form";
import { isRequired } from "./formHelper.js";

export default {
    name: "StepEmployment",
    components: {
        InputText,
        InputRadioGroup,
        InputNumber,
        InputYearsMonths,
    },
    methods: {
        getField(fieldName) {
            return this.fields[fieldName];
        },
        isRequired(fieldName) {
            var fieldData = this.getField(fieldName);
            return isRequired(fieldData, this.form);
        },
         clearfields() {
            if (this.form.has_never_worked == true) {
                this.form.how_long_since_last_worked_years = null;
                this.form.how_long_since_last_worked_months = null;
            }

        },
    },
    data () {
        return {
            form: new Form({
                is_eligible_to_work: null,
                ineligibility_reason: null,
                ineligibility_reason_other_text: null,
                current_employment_situation: null,
                average_weekly_work_hours: null,
                is_zero_hour_contract: null,
                how_long_since_last_worked_years: null,
                how_long_since_last_worked_months: null,
                has_never_worked: false,
                why_unable_to_work: null,
                volunteering_hours_per_week: null,
            }, this.formData),
        };
    },
    props: {
        step: Object,
        fields: Object,
        formData: Object,
    },
};
</script>
